var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2GolfWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9414 5.28318C20.4498 4.95582 21.0897 4.9092 21.6401 5.15941L33.4595 10.5319C34.0944 10.8204 34.502 11.4535 34.502 12.1509C34.502 12.8483 34.0944 13.4814 33.4595 13.77L22.6827 18.6685V28.5967C24.7467 28.2853 26.9238 28.12 29.1666 28.12C35.3171 28.12 40.9732 29.3627 45.1575 31.4549C49.2355 33.4938 52.4348 36.6397 52.4348 40.6433C52.4348 44.647 49.2355 47.7928 45.1575 49.8318C40.9732 51.924 35.3171 53.1667 29.1666 53.1667C23.0162 53.1667 17.3601 51.924 13.1757 49.8318C9.09781 47.7928 5.89844 44.647 5.89844 40.6433C5.89844 36.6397 9.09781 33.4938 13.1757 31.4549C14.9255 30.58 16.9327 29.8536 19.1257 29.3046V6.77847C19.1257 6.17379 19.433 5.61054 19.9414 5.28318ZM40.5785 40.8657C40.5785 42.5845 39.185 43.978 37.4662 43.978C35.7473 43.978 34.3538 42.5845 34.3538 40.8657C34.3538 39.1468 35.7473 37.7534 37.4662 37.7534C39.185 37.7534 40.5785 39.1468 40.5785 40.8657Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2GolfWhite);
export default __webpack_public_path__ + "static/media/v2-golf-white.8145d180922ab3199b500ee6fa441e38.svg";
export { ForwardRef as ReactComponent };